import { Heat, HeatAllDTO } from "@/models/heats/heat-all.dto";
import { getFutureHeats } from "@/store/heats/heats.thunks";
import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
	selectedHeat?: Heat | null;
	allHeats: {
		allHeatsDTO?: HeatAllDTO;
		isAllHeatsDTOLoading?: boolean;
		timerIsOn: boolean;
	};
	filters: {
		startDateTime: Date | null;
		endDateTime: Date | null;
		rootId?: number;
		ladles: string[] | null;
		reverseSort: boolean;
		highlight: boolean;
		heatName: string;
		interval: "" | "latest" | "12h" | "24h";
		caster: "all" | "1" | "2";
	};
	createHeat: {
		futureHeats?: string[];
		isFutureHeatsLoading: boolean;
	};
}

const initialState: InitialState = {
	allHeats: {
		timerIsOn: true,
	},
	filters: {
		reverseSort: false,
		startDateTime: null,
		endDateTime: null,
		highlight: true,
		ladles: null,
		heatName: "",
		interval: "",
		caster: "all",
	},
	createHeat: {
		futureHeats: [],
		isFutureHeatsLoading: true,
	},
};

export const ladles24hReducer = createSlice({
	name: "@ladles-24h",
	initialState,
	reducers: {
		setSelectedHeat(state, { payload }) {
			state.selectedHeat = payload;
		},
		setHeatsIsLoading(state, { payload }) {
			state.allHeats.isAllHeatsDTOLoading = payload;
		},
		setAllHeats(state, { payload }) {
			state.allHeats = {
				isAllHeatsDTOLoading: false,
				allHeatsDTO: payload,
				timerIsOn: state.allHeats.timerIsOn,
			};
		},
		setTimerIsOn(state, { payload }) {
			state.allHeats.timerIsOn = payload;
		},
		setIntervalFilter(state, action) {
			if (action.payload !== "") {
				state.filters.startDateTime = null;
				state.filters.endDateTime = null;
			}
			state.filters.interval = action.payload;
		},
		setStartDateFilter(state, action) {
			state.filters.startDateTime = action.payload;
		},
		setEndDateFilter(state, action) {
			state.filters.endDateTime = action.payload;
		},
		setReverseSortFilter(state) {
			state.filters.reverseSort = !state.filters.reverseSort;
		},
		setLadlesFilter(state, action) {
			state.filters.ladles = action.payload;
		},
		setHighlightFilter(state, action) {
			state.filters.highlight = action.payload;
		},
		setHeatNameFilter(state, action) {
			state.filters.heatName = action.payload;
		},
		setFutureHeats(state, action) {
			state.createHeat.futureHeats = action.payload;
		},
		setCasterFilter(state, action) {
			state.filters.caster = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getFutureHeats.pending, (state, action) => {
				state.createHeat.isFutureHeatsLoading = true;
			})
			.addCase(getFutureHeats.fulfilled, (state, action) => {
				state.createHeat.futureHeats = action.payload.data;
			});
	},
});

export const {
	setStartDateFilter,
	setEndDateFilter,
	setHighlightFilter,
	setLadlesFilter,
	setReverseSortFilter,
	setHeatNameFilter,
} = ladles24hReducer.actions;
